import React, { Suspense } from "react";
import { BrowserRouter as Router, Routes as RoutesContainer, Route } from "react-router-dom";
import { Box, CircularProgress } from "@mui/material";
import PrivateRoute from "~/presentation/routes/PrivateRoute";
import { makeLoginPage } from "~/main/factories/pages/login";
import { SecurityRoute } from "../security/SecurityPath";
import { clientPerms } from "../security/SecurePaths";
import { DialogUnauthorized } from "../components/DialogUnauthorized/DialogUnauthorized";
import HelpCenter from "~/presentation/components/HelpCenter";

const AdminRoutes = React.lazy(() => import("~/presentation/routes/AdminRoutes"));
const ClientRoutes = React.lazy(() => import("~/presentation/routes/ClientRoutes"));
const GTFacilRoutes = React.lazy(() => import("~/presentation/routes/GTFacilRoutes"));
const ReinfRoutes = React.lazy(() => import("~/presentation/routes/ReinfRoutes"));

const RouteLoadingFallback = () => (
  <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "60vh" }}>
    <CircularProgress />
  </Box>
);

const Routes = () => (
  <Router>
    <Suspense fallback={<RouteLoadingFallback />}>
      <RoutesContainer>
        <Route
          path="/cliente/*"
          element={
            <PrivateRoute>
              <ClientRoutes />
            </PrivateRoute>
          }
        />

        <Route
          path="/gt-facil/*"
          element={
            <PrivateRoute>
              <SecurityRoute
                securePaths={[
                  clientPerms.seeCnaeResearch,
                  clientPerms.seeLcResearch,
                  clientPerms.seeFreeSearch,
                ]}
                returnTo="/cliente"
              >
                <GTFacilRoutes />
              </SecurityRoute>
            </PrivateRoute>
          }
        />

        <Route
          path="/admin/*"
          element={
            <PrivateRoute>
              <SecurityRoute secureMainRoute="admin" returnTo="/cliente">
                <AdminRoutes />
              </SecurityRoute>
            </PrivateRoute>
          }
        />

        <Route
          path="/reinf/*"
          element={
            <PrivateRoute>
              <SecurityRoute secureMainRoute="reinf" returnTo="/cliente">
                <ReinfRoutes />
              </SecurityRoute>
            </PrivateRoute>
          }
        />

        <Route path="/" element={makeLoginPage()} />
        <Route path="*" element={() => <h1>404 Not found</h1>} />
      </RoutesContainer>
    </Suspense>
    <DialogUnauthorized />
    <HelpCenter />
  </Router>
);

export default Routes;
